export default {
    header: "{name} rendjei",
    error: "Hiba történt",
    empty: "Nem található megrendelés",
    system: "Ügyfélszolgálat",
    orders: {
        name: "Név",
        date: "Dátum",
        status: "Állapot",
        approvedBy: "Jóváhagyta"
    },
    cta: {
        close: "Közeli"
    }
}